import { createSlice } from '@reduxjs/toolkit';
// utils
import { SERVER_API } from '../../config-global';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  events: [],
  eventDetails: null,
  award: [],
  addedTrainee: null,
  trainingList: [],
  DelegateDaysByEventBreakdown: [],
  EventSegment: [],
  FiveCard: [],
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    AdminDashboard_SelectAwardSuccess(state, action) {
      state.isLoading = false;
      state.awardData = action.payload;
    },
    AdminDashboard_TotalSecuredEventsSuccess(state, action) {
      state.isLoading = false;
      state.TotalSecuredEvents = action.payload;
    },
    AdminDashboard_DirectDelegatesExpenditureSuccess(state, action) {
      state.isLoading = false;
      state.DirectDelegatesExpenditure = action.payload;
    },

    AdminDashboard_DelegateDaysByEventBreakdownSuccess(state, action) {
      state.isLoading = false;
      state.DelegateDaysByEventBreakdown = action.payload;
    },

    AdminDashboard_EventSegmentSuccess(state, action) {
      state.isLoading = false;
      state.EventSegment = action.payload;
    },

    AdminDashboard_FiveCardSuccess(state, action) {
      state.isLoading = false;
      state.FiveCard = action.payload;
    },

    // CLEAR ERROR
    clearError(state) {
      state.error = null;
    },

    // CLEAR EVENT DETAILS
    clearEventDetails(state, action) {
      state.eventDetails = null;
    },

    addTraineeSuccess(state, action) {
      state.isLoading = false;
      state.addedTrainee = action.payload;
    },

    getTrainingListSuccess(state, action) {
      state.isLoading = false;
      state.trainingList = action.payload;
    },

    clearAddedTrainee(state, action) {
      state.isLoading = false;
      state.addedTrainee = null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { clearError, clearEventDetails, clearAddedTrainee } = slice.actions;

// ----------------------------------------------------------------------

export function AdminDashboard_SelectAward() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_SelectAward`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.AdminDashboard_SelectAwardSuccess(JSON.parse(data.ReturnData)));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_TotalSecuredEvents() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_TotalSecuredEvents`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.AdminDashboard_TotalSecuredEventsSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_DirectDelegatesExpenditure() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_DirectDelegatesExpenditure`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.AdminDashboard_DirectDelegatesExpenditureSuccess(
              JSON.parse(data.ReturnData)
            )
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_DelegateDaysByEventBreakdown() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_DelegateDaysByEventBreakdown`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.AdminDashboard_DelegateDaysByEventBreakdownSuccess(
              JSON.parse(data.ReturnData)
            )
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_EventSegment() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_EventSegment`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.AdminDashboard_EventSegmentSuccess(JSON.parse(data.ReturnData)));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_FiveCard() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_FiveCard`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.AdminDashboard_FiveCardSuccess(JSON.parse(data.ReturnData)));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addTrainee(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const requestUrl = `${SERVER_API}Admin_InsertTraningList?trainingPIC=${data.traineeName}&designation=${data.designation}&phoneNumber=${data.phoneNo}&email=${data.email}&trainingOrganization=${data.organization}&trainingYear=${data.trainingYear}&trainingLocality=${data.locality}&courseName=${data.course}&CreatedBy=${data.createdBy}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const result = JSON.parse(json)[0];

      if (result && result.ReturnVal === 1) {
        dispatch(slice.actions.addTraineeSuccess(JSON.parse(result.ReturnData)[0]));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(result.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTrainingList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const requestUrl = `${SERVER_API}AdminDashboard_SelectAllListIntoListOfTraining`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const result = JSON.parse(json)[0];

      if (result && result.ReturnVal === 1) {
        dispatch(slice.actions.getTrainingListSuccess(JSON.parse(result.ReturnData)));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(result.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
